module.exports = {
          srcSet: __webpack_public_path__ + "0890f1ef.jpg"+" 330w",
          images:[ {path: __webpack_public_path__ + "0890f1ef.jpg",width: 330,height: 200}],
          src: __webpack_public_path__ + "0890f1ef.jpg",
          toString:function(){return __webpack_public_path__ + "0890f1ef.jpg"},
          
          width: 330,
          height: 200
        }